"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alarmIcon = void 0;
var alarmIcon = "<svg class=\"MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSvgIcon-root MuiSvgIcon-fontSizeLarge\" style=\"width: 24px; height: 24px; color: #fff;\" focusable=\"false\" viewBox=\"0 0 24 24\" aria-hidden=\"true\" data-testid=\"PriorityHighIcon\" tabindex=\"-1\"><circle cx=\"12\" cy=\"19\" r=\"2\"></circle><path d=\"M10 3h4v12h-4z\"></path></svg>";
exports.alarmIcon = alarmIcon;